<template>
  <section id="products" class="scroll-mt-24 py-32">
    <div class="page-shell">
      <div>
        <h2 class="section-title">{{ t(sectionTitle) }}</h2>
        <p class="mt-1 text-sm text-[#8b8b99]">{{ t(sectionSubtitle) }}</p>
      </div>

      <section
        v-for="category in categories"
        :key="category.id"
        class="mt-24"
        :aria-labelledby="`${category.id}-title`"
      >
        <div class="max-w-3xl">
          <div class="flex items-center gap-3">
            <span class="h-5 w-0.5" :style="{ backgroundColor: accentLineMap[category.accent] }"></span>
            <h2 :id="`${category.id}-title`" class="text-xl font-semibold text-[#f1f1f3]">
              {{ t(category.label) }}
            </h2>
          </div>
          <p class="mt-3 text-sm leading-7 text-[#8b8b99]">{{ t(category.desc) }}</p>
        </div>

        <div
          :class="
            category.id === 'enterprise'
              ? 'mt-8 grid max-w-2xl grid-cols-1 gap-5'
              : 'mt-8 grid grid-cols-1 gap-5 md:grid-cols-2'
          "
        >
          <ProductCard
            v-for="(product, index) in category.products"
            :key="product.id"
            :product="product"
            :delay="index * 100"
          />
        </div>
      </section>
    </div>
  </section>
</template>

<script setup>
import ProductCard from './ProductCard.vue'
import { categories } from '../data/products'
import { useI18n } from '../composables/useI18n'

const { t } = useI18n()
const sectionTitle = {
  zh: '我们的产品',
  en: 'Our Products',
  es: 'Nuestros Productos',
  fr: 'Nos Produits',
  ja: 'プロダクト',
}
const sectionSubtitle = {
  zh: '产品矩阵',
  en: 'Product Portfolio',
  es: 'Portafolio de productos',
  fr: 'Portefeuille produits',
  ja: '製品ポートフォリオ',
}

const accentLineMap = {
  amber: '#e8c96a',
  blue: '#60a5fa',
  slate: '#94a3b8',
}
</script>
